import React, { useState,useEffect} from 'react'
// import Swipe from "react-easy-swipe";
import Swipe from "react-easy-swipe"
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
// import Showcase from './Showcase';
import c1 from '../../assets/images/carousel/1.jpg';
import c2 from '../../assets/images/carousel/2.jpg';
import c3 from '../../assets/images/carousel/3.jpg';
import c4 from '../../assets/images/carousel/4.jpg';
// import c5 from '../../assets/images/carousel/5.jpg';
import c6 from '../../assets/images/carousel/6.jpg';
import c7 from '../../assets/images/carousel/7.jpg';
// import c8 from '../../assets/images/carousel/8.jpg';
// import c9 from '../../assets/images/carousel/9.jpg';
import c10 from '../../assets/images/carousel/10.jpg';
import c11 from '../../assets/images/carousel/11.jpg';
import c12 from '../../assets/images/carousel/12.jpg';
import c13 from '../../assets/images/carousel/13.jpg';


// const backet = 'https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets';

function Carousels1() {
    // Filter out undergraduate admission images - mark admission-related slides with isUndergraduateAdmission: true
    // The "ADMISSIONS OPEN Academic Year 2025-2026" banner is marked for removal
    const allSlides = [
      // First image: "Welcome To Benadir University" with student
      {url: c1, title: "Welcome To Benadir University", description: "No. 1 University in Somalia", command:"Learn more", link: "#", isUndergraduateAdmission: false},
      {url: c3,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c4,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c6,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c7,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c11, title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c12,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c13,title: "Banadir University", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Apply now", link: "#", isUndergraduateAdmission: false},
      {url: c10,title: "Campus Tour", description: "In Somalia, BU has the largest range of medical educations and accounts for the single largest share of medical academic research.", command:"Register here", link: "#", isUndergraduateAdmission: true} // Admission image - "ADMISSIONS OPEN Academic Year 2025-2026"
    ]

    // Filter out undergraduate admission images (slides with isUndergraduateAdmission: true will be excluded)
    const slides = allSlides.filter(slide => !slide.isUndergraduateAdmission);

    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect( ()=> {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const isLastSlide = prevIndex === slides.length -1;
          return isLastSlide ? 0 : prevIndex + 1;
        });
      }, 4000);
      return () => clearInterval(interval);
    }, [slides.length])

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1: currentIndex -1;
        setCurrentIndex(newIndex)
    }
    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length -1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex)
    }
    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
      };
  return (
    <Swipe onSwipeLeft={prevSlide} onSwipeRight={nextSlide} >
    <div className='  w-full  xl:pt-[95px] md:pt-[95px] sm:pt-[95px] xs:pt-[75px] relative group'>
      <img src={slides[currentIndex].url} alt="carousels" className='w-full h-full   bg-cover bg-center duration-500'/>
    {/* <div style={{ backgroundImage: `url(${slides[currentIndex].url})` }} className='w-full h-full   bg-cover bg-center duration-500' > */}
      {/* <Showcase title={slides[currentIndex].title} description={slides[currentIndex].description} command={slides[currentIndex].command} link={slides[currentIndex].link}/> */}
    {/* </div> */}
  
    {/* Left Arrow */}
    <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
      <BsChevronCompactLeft onClick={prevSlide} size={30} />
    </div>
    {/* Right Arrow */}
    <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
      <BsChevronCompactRight onClick={nextSlide} size={30} />
    </div>
    <div className='absolute w-full flex justify-center bottom-0 xs:hidden'>
      {slides.map((slide, slideIndex) => (
        <div
          key={slideIndex}
          onClick={() => goToSlide(slideIndex)}
          className={slideIndex === currentIndex
                      ? "h-4 w-4 bg-blue-700 rounded-full mx-2 mb-2 cursor-pointer"
                      : "h-4 w-4 bg-white rounded-full mx-2 mb-2 cursor-pointer"}
        >
        </div>
      ))}
    </div>
  </div>
    </Swipe>
  )
}

export default Carousels1